const routeNames = {
  general: {
    landing: "/",
    search: "/search",
    search2: "/search/:keyword/:location",
    search3: "/search/location=:location",
    search4: "/search/keyword=:keyword",
    employer: "/employer/signup",
    jobSeeker: "/job-seeker",
    viewJob: "/job/:jobId",
    login: "/login",
    aboutUs: "/aboutus",
    contactus: "/contactus",
    terms: "/terms-of-use",
    privacy: "/privacy-policy",
    faqs: "/faqs",
  },
  employer: {
    dashboard: "/employer/",
    postAJob: "/employer/jobPost",
    myJobs: "/employer/myJobs",
    searchJokSeeker: "/employer/searchJobSeeker",
    savedSeekers: "/employer/saved",
    analytics: "/employer/analytics",
    connections: "/employer/connections",
    favourites: "/employer/favourites",
    messages: "/employer/messages",
    notifications: "/emplpoyer/notifications",
    myProfile: "/employer/myprofile",
    viewProfile: "/employer/profile/:id",
    settings: "/employer/settings",
    myposts: "/employer/settings/:tab",
  },
  jobSeeker: {
    dashboard: "/jobSeeker/",
    connections: "/jobSeeker/connections/",
    homeFeed: "/jobSeeker/home",
    searchJob: "/jobSeeker/searchjob",
    searchPeople: "/jobSeeker/searchpeople",
    searchCompany: "/jobSeeker/searchCompany",
    settings: "/jobSeeker/settings",
    myProfile: "/jobSeeker/myprofile",
    viewCompany: "/jobSeeker/company/companyprofile/:id",
    viewProfile: "/jobSeeker/profile/:id",
    jobapplications: "/jobSeeker/jobapplications",
    messages: "/jobSeeker/messages",
    myposts: "/jobSeeker/myPosts",
    followedCompanyPosts: "/jobSeeker/companyPosts/:companyId",
  },
  admin: {
    home: "/admin/",
    dashboard: "/admin/",
    viewCompanies: "/admin/viewCompanies",
    viewJobSeekers: "/admin/viewJobSeekers",
    viewAdmins: "/admin/viewAdmins",
    addUsers: "/admin/addUsers",
    userRoles: "/admin/userRoles",
    FAQCategory: "/admin/FAQCategory",
    FAQ: "/admin/FAQ",
    skills: "/admin/skills",
    industries: "/admin/industries",
    industryTypes: "/admin/industryTypes",
    categories: "/admin/categories",
    degrees: "/admin/degrees",
    interests: "/admin/interests",
    majors: "/admin/majors",
    jobs: "/admin/jobs",
    minors: "/admin/minors",
    lookups: "/admin/lookups",
    lookupsLists: "/admin/lookupsLists",
    lookupsTypes: "/admin/lookupTypes",
    viewUsers: "/admin/viewUsers",
    education: "/admin/education",
    employmentHistory: "/admin/employmentHistory",
    skillsAndMore: "/admin/SkillsAndMore",
    documentLookups: "/admin/documentLookups",
    webLinkLookups: "/admin/webLinkLookups",
    editProfile: "/admin/editProfile",
    profileInformation: "/admin/profileInformation",
  },
};

export default routeNames;
